import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class AudienceIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12"><path fillRule="evenodd" d="M11.13 8.524c.34-.27.365-.628.14-1.105a19.186 19.186 0 0 1-.81-1.974 3.194 3.194 0 0 1-.046-1.892c.249-.922.956-1.54 1.934-1.67.709-.094 1.385-.024 1.987.397.898.628 1.065 1.531.96 2.51-.096.908-.437 1.75-.876 2.554-.375.688-.234 1.125.512 1.409.487.185 1.004.294 1.507.438.207.06.421.103.617.186.38.162.661.42.708.848.05.45.191 1.305.237 1.775h-5.28c-.02-.423-.039-.735-.058-.936-.039-.413-.064-.8-.093-1.065-.085-.779-.517-1.156-1.34-1.437a1.79 1.79 0 0 1-.099-.038zM0 12c.09-1.263.097-1.613.298-2.233.125-.386.445-.636.837-.755.558-.169 1.13-.293 1.69-.455a6.36 6.36 0 0 0 .98-.35c.703-.337.82-.825.492-1.522a23.013 23.013 0 0 1-.973-2.369 3.831 3.831 0 0 1-.055-2.269C3.567.942 4.416.2 5.59.044 6.44-.068 7.251.015 7.972.52c1.077.754 1.278 1.837 1.153 3.01-.117 1.09-.525 2.101-1.051 3.065-.451.825-.281 1.349.614 1.69.583.221 1.203.352 1.807.525.248.071.505.123.74.223.456.194.793.504.849 1.018.06.538.087 1.385.142 1.949H0z"/></svg>
        )
    }
}

export default withCssClassName(AudienceIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/audience-icon.js